import * as client from "../ClientConsumer";
import { generatePath } from "react-router-dom";
import {
    PlaceImageData,
    PointOfInterestResponse,
} from "../../Presentation/Components/Group/PointsOfInterest/PointsOfInterest.types";

const routes = {
    GET_POI: "/community/poi/:id",
    GET_PLACE_IMAGE: "/community/place/image",
};

export async function getPoi(
    id: string,
    groupId?: number,
    poiId?: number,
): Promise<PointOfInterestResponse> {
    return client
        .getData(generatePath(routes.GET_POI, { id }), {
            params: { groupId, poiId },
        })
        .then((res) => res.data);
}

export async function getPlaceImage(
    placeId: string | undefined,
    poiId: string | undefined,
    abortSignal: AbortSignal,
): Promise<PlaceImageData> {
    return client
        .getData(routes.GET_PLACE_IMAGE, {
            params: { placeId, poiId },
            signal: abortSignal,
        })
        .then((res) => res.data);
}
